import api from '../api/api';
import { Grade, GradeCreate, GradeUpdate, GradeSummary, ExamGradeSummary } from '../types';

export const getGrades = async (): Promise<Grade[]> => {
  const response = await api.get('/grades/?limit=10000');
  const data = response.data as { grades: Grade[]; total: number };
  return data.grades || [];
};

export const getGrade = async (gradeId: number): Promise<Grade> => {  
  const response = await api.get(`/grades/${gradeId}`);
  return response.data as Grade;
};

export const getStudentGrades = async (studentId: number, examId?: number): Promise<Grade[]> => {
  try {
    let url = `/grades/student/${studentId}?limit=10000`;
    if (examId) {
      url += `&exam_id=${examId}`;
    }
    const response = await api.get(url);
    return response.data as Grade[];
  } catch (error) {
    console.error('Failed to fetch student grades:', error);
    throw error;
  }
};

export const getCourseGrades = async (courseId: number): Promise<Grade[]> => {
  const response = await api.get(`/grades/course/${courseId}?limit=10000`);
  return response.data as Grade[];
};

export const getSchoolGrades = async (schoolId: number): Promise<Grade[]> => {
  const response = await api.get(`/grades/school/${schoolId}?limit=10000`);
  return response.data as Grade[];
};

export const getExamGrades = async (examId: number): Promise<Grade[]> => {
  const response = await api.get(`/grades/exam/${examId}?limit=10000`);
  return response.data as Grade[];
};

export const createGrade = async (grade: GradeCreate): Promise<Grade> => {
  const response = await api.post('/grades', grade);
  return response.data as Grade;
};

export const updateGrade = async (gradeId: number, grade: GradeUpdate): Promise<Grade> => {
  const response = await api.put(`/grades/${gradeId}`, grade);
  return response.data as Grade;
};

export const deleteGrade = async (gradeId: number): Promise<void> => {
  await api.delete(`/grades/${gradeId}`);
};

export const getStudentGradesSummary = async (studentId: number, examId?: number): Promise<GradeSummary> => {
  try {
    let url = `/grades/student/${studentId}/summary`;
    if (examId) {
      url += `?exam_id=${examId}`;
    }
    const response = await api.get(url);
    return response.data as GradeSummary;
  } catch (error) {
    console.error('Failed to fetch student grades summary:', error);
    throw error;
  }
};

export const getExamGradesSummary = async (examId: number): Promise<ExamGradeSummary> => {
  const response = await api.get(`/grades/exam/${examId}/summary`);   
  return response.data as ExamGradeSummary;
};

// Bulk grade operations
export const createBulkGrades = async (grades: GradeCreate[]): Promise<Grade[]> => {
  const response = await api.post('/grades/bulk', grades);
  return response.data as Grade[];
};

export const updateBulkGrades = async (grades: { id: number; data: GradeUpdate }[]): Promise<Grade[]> => {
  const response = await api.put('/grades/bulk', grades);
  return response.data as Grade[];
};

export const upsertBulkGrades = async (grades: (GradeCreate | { id: number; data: GradeUpdate })[]): Promise<Grade[]> => {
  const response = await api.post('/grades/bulk/upsert', grades);     
  return response.data as Grade[];
}; 